import React from "react";
import { useTranslation } from "react-i18next";

import Layout from "../../../components/v2/Layout";
import PageTitle from "../../../components/v2/PageTitle";
import ServiceCard from "../../../components/v2/Servicos/ServiceCard";

import style from "./styles.module.scss";

const keyI18n = "translations.services";

const digitalLibraryUrl =
  "https://signon.thomsonreuters.com/?productid=EREAD&viewproductid=EREAD&returnto=https%3A%2F%2Fproview.thomsonreuters.com%2Flogin.html&culture=pt-BR&lr=0&bhcp=1";

interface ServiceEntry {
  slug: string;
  icon: string;
  href: string;
  external?: boolean;
}

const services: ServiceEntry[] = [
  { slug: "debts", icon: "mintmark", href: "/consultar/debitos/em_aberto" },
  { slug: "installments", icon: "checkbook", href: "/consultar/parcelamentos" },
  { slug: "protested", icon: "currency_exchange", href: "/consultar/protestos" },
  { slug: "signature", icon: "signature", href: "/validar-documento" },
  {
    slug: "digitalLibrary",
    icon: "local_library",
    href: digitalLibraryUrl,
    external: true,
  },
];

export default function Servicos() {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${keyI18n}.title`)}>
      <div className={style.body}>
        <PageTitle
          subtitle={t(`${keyI18n}.subtitle`)}
          title={t(`${keyI18n}.title`)}
        />

        <div className={style.list}>
          {services.map(({ slug, icon, href, external }) => (
            <ServiceCard
              description={t(`${keyI18n}.items.${slug}.description`)}
              external={external}
              href={href}
              icon={icon}
              key={slug}
              title={t(`${keyI18n}.items.${slug}.title`)}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
}
